export enum AccountTypeEnum {
  BUDGET = 'Budget',
  ADDITIONAL_ORDER = 'Zusatzauftrag',
  GK_INTERN = 'GKintern',
  ACQUISITION = 'Zukauf',
}
